import React from 'react';
import {observer} from 'mobx-react';
import {DatePicker, EmailTemplatePreview, FormLayout} from 'components';
import {Modal, ModalButtons} from 'components/modals';
import {FormattedMessage} from 'react-intl';
import {auth} from 'shared/core';
import {calendarDate} from 'shared/tools';

const LaunchModal = observer(({uiState}) => {
  const {cycle, scheduledLaunch, errors} = uiState;

  return (
    <Modal 
      title='performance_reviews.manage.Launch Reviews'
      description={
        auth.featureEnabled(':scheduled_reviews') ? 
          'performance_reviews.manage.REVIEW_LAUNCH_DESCRIPTION' :
          'performance_reviews.manage.Please select a date by which all performance reviews should be completed. This date will also be used to trigger automated reminder emails. Once a review is launched it will no longer be editable and reviewers will be able to complete and submit performance reviews.'
      }
      isOpen={uiState.launchCycleModalOpen}
      onHide={() => uiState.closeLaunchCycleModal()}
      size='md'
    >
      <FormLayout>
        {auth.featureEnabled(':scheduled_reviews') && <DatePicker
          label='performance_reviews.manage.Launch date'
          value={cycle.launchDate}
          onChange={(date) => cycle.merge({launchDate: date})}
          options={{startDate: '0'}}
          className='full-width'
          errorMessage={errors.launchDate}
        />}
        <DatePicker
          label='performance_reviews.manage.Due date'
          value={cycle.dueDate}
          onChange={(date) => cycle.merge({dueDate: date})}
          options={{startDate: '0'}}
          className='full-width'
          errorMessage={errors.dueDate}
        />
        <div>
          <div>
            <FormattedMessage id='performance_reviews.manage.Launch email preview'/>
          </div>
          <div className='clearfix pb2 jumbo'>
            <FormattedMessage id={scheduledLaunch ? 'performance_reviews.manage.SCHEDULED_NUMBER_OF_REVIEWERS' : 'performance_reviews.manage.NUMBER_OF_REVIEWERS'} values={{reviewerCount: cycle.reviewersCount, date: calendarDate(cycle.launchDate)}}/>
          </div>
          <EmailTemplatePreview template={uiState.emailPreview}/>
        </div>
        <ModalButtons
          saveCaption={scheduledLaunch ? 'performance_reviews.manage.Schedule Reviews' : 'performance_reviews.manage.Launch Reviews'}
          onSave={() => uiState.launchCycle()}
          onCancel={() => uiState.closeLaunchCycleModal()}
          enabled={!uiState.isLaunching}
        />
      </FormLayout>
    </Modal>
  );
});

export default LaunchModal;
